module.exports = __webpack_public_path__ + "img/img-avatar11.f00a269c.jpg";